import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class W9StateService {
  private companyId: string = '';

  setCompanyId(id: string) {
    this.companyId = id;
  }

  getCompanyId(): string {
    return this.companyId;
  }
}